<template>
  <div class="basicForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <el-form-item label="账户" prop="userNumber">
        <el-input v-model="form.userNumber" disabled />
      </el-form-item>
      <el-form-item label="经销商" prop="fName">
        <el-input v-model="form.fName" disabled />
      </el-form-item>
      <el-form-item label="类型" prop="modifyType">
        <el-select v-model="form.modifyType">
          <el-option label="充值" value="充值" />
          <el-option label="支出" value="支出" />
        </el-select>
      </el-form-item>
      <el-form-item label="金额" prop="fMoney">
        <el-input-currency v-model="form.fMoney" :scale="2" size="" />
      </el-form-item>
      <el-form-item label="说明" prop="fDes">
        <el-input v-model="form.fDes" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import md5 from 'md5'

export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        modifyType: [{ required: true, message: '必填项', trigger: 'change' }],
        fMoney: [{ required: true, message: '必填项', trigger: 'change' }],
        fDes: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  computed: {
  },
  mounted: function() {
    // console.log(this.form, 'form')
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" >
 .basicForm{
.el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
 .flex-item {
    display: flex;
    width:95%;
    & > .el-form-item {
      flex: 0 0 25%;
      display: flex;

      & .el-input, &.el-select {
        width: 100%;
      }
    }
  }
}
</style>
